import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import { urls } from 'constants/urls';
import { useCustomerOrderContext } from 'contexts/CustomerOrder';
import { useTrackedExperiments } from 'contexts/TrackedExperiments';

export const URGENCY_BANNER = {
  experiment: 'urgencyBanner',
  variant: {
    default: 'default',
    danger: 'danger',
    warning: 'warning',
    info: 'info',
  },
};

export function useUrgencyBanner():
  | ['payment', null]
  | ['info' | 'warning' | 'danger', object | null | undefined]
  | [null, null] {
  const { getExperimentById } = useTrackedExperiments();
  const { customerOrderStatsContext } = useCustomerOrderContext();
  const customerHasAnOrderRequiringPaymentAttention =
    customerOrderStatsContext?.customerHasAnOrderRequiringPaymentAttention;

  const location = useLocation();
  const isMyOrdersPage = useMemo(
    () =>
      !!matchRoutes(
        [
          { path: urls.myOrdersPage },
          { path: urls.viewOrder },
          { path: urls.checkout },
          { path: urls.resolveOrderPayment },
        ],
        location,
      ),
    [location],
  );

  const { variant, payload } = getExperimentById(URGENCY_BANNER.experiment);

  if (
    customerHasAnOrderRequiringPaymentAttention &&
    !isMyOrdersPage &&
    variant !== URGENCY_BANNER.variant.danger
  ) {
    return ['payment', null];
  }

  switch (variant) {
    case URGENCY_BANNER.variant.info:
      return ['info', payload];
    case URGENCY_BANNER.variant.warning:
      return ['warning', payload];
    case URGENCY_BANNER.variant.danger:
      return ['danger', payload];
    default:
      return [null, null];
  }
}
